import { createSlice } from "@reduxjs/toolkit";
import { orderStatusUpdate } from "./orderAsyncThunk";

const orderStatusUpdateSlice = createSlice({
  name: "order",
  initialState: {
    isLoading: false,
    isSuccess: false,
    payload: "",
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [orderStatusUpdate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [orderStatusUpdate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isFail = false;
      state.payload = action.payload.message;
    },
    [orderStatusUpdate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFail = true;
    },
  },
});

export default orderStatusUpdateSlice.reducer;
